// import and declare local image assets
import React from "react";
import { SxProps, Theme } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Add from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import Logo from "../Assets/logo.png";
import ContactBg from "../Assets/contact-bg-shape.png";
import LinearMoneys from "../Assets/linear_moneys.png";
import LowRawMaterials from "../Assets/low_raw_materials.png";
import OrdersFullFilled from "../Assets/orders_fullfilled.png";
import OutOfStockItems from "../Assets/out_of_stock_items.png";
import RecentCalls from "../Assets/recent_calls.png";
import QuickOrder1 from "../Assets/Quick_Order_1.png";
import QuickOrder2 from "../Assets/Quick_Order_2.png";
import QuickOrder3 from "../Assets/Quick_Order_3.png";
import samProfile from "../Assets/profile-sample.png";
import iconLinearExport from "../Assets/icon-linear-export.png";
import RecommendedProducts from "../Assets/recommended_products.webp";
import CompanyLogo from "../Assets/copmay_logo.png";
import NewLogo from "../Assets/new_logo.png";
import hoverlineIcon from "../Assets/hoverlineIcon.png"
import defaultLineIcon from "../Assets/defaultLineIcon.png"

export const LocalImage = {
  logo: Logo,
  contactBg: ContactBg,
  linearMoneys: LinearMoneys,
  lowRawMaterials: LowRawMaterials,
  ordersFullFilled: OrdersFullFilled,
  outOfStockItems: OutOfStockItems,
  recentCalls: RecentCalls,
  quickOrder1: QuickOrder1,
  quickOrder2: QuickOrder2,
  quickOrder3: QuickOrder3,
  samProfile: samProfile,
  iconLinearExport: iconLinearExport,
  recommendedProducts: RecommendedProducts,
  companyLogo: CompanyLogo,
  newLogo: NewLogo,
  hoverlineIcon: hoverlineIcon,
  defaultLineIcon: defaultLineIcon,
};

export const ArrowForwardIcon = ({
  color = "#000",
  size = 16,
}: {
  color?: string;
  size?: number;
}) => <ArrowForwardIosIcon sx={{ color: color, fontSize: size }} />;

export const AddIcon = ({
  color = "#000",
  size = 16,
}: {
  color?: string;
  size?: number;
}) => <Add sx={{ color: color, fontSize: size }} />;

export const ArrowDownIcon = ({
  color = "#000",
  size = 16,
  style,
}: {
  color?: string;
  size?: number;
  style?: SxProps<Theme> | undefined;
}) => <KeyboardArrowDownIcon sx={{ color: color, fontSize: size, ...style }} />;
